import React from 'react';
import { useNavigate } from 'react-router-dom';

// PrivateRoute Component
// This component restricts access to its children based on the `isAuthenticated` prop.
// If the user is authenticated, it renders the children (protected content).
// Otherwise, it displays a message prompting the user to sign in.

const PrivateRoute = ({ isAuthenticated, children, userRole }) => {
  const navigate = useNavigate();

  // If user is authenticated but has no role (account not found), redirect to signup
  if (isAuthenticated && userRole === null) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
        <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-11/12 text-center">
          <h1 className="text-2xl font-semibold text-gray-700 mb-4">
            Account Setup Required
          </h1>
          <p className="text-gray-600 mb-6">
            Your account needs to be set up. Please complete the signup process.
          </p>
          <button
            onClick={() => navigate('/signup', { replace: true })}
            className="bg-teal-500 text-white py-2 px-6 rounded-lg shadow hover:bg-teal-600 focus:ring-2 focus:ring-teal-300 transition"
          >
            Complete Signup
          </button>
        </div>
      </div>
    );
  }

  return isAuthenticated ? (
    // Render the protected content if the user is authenticated
    children
  ) : (
    // Render the sign-in prompt if the user is not authenticated
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-11/12 text-center">
        <h1 className="text-2xl font-semibold text-gray-700 mb-4">
          Please sign in to access this page.
        </h1>
        <button
          onClick={() => navigate('/signin', { replace: true })}
          className="bg-teal-500 text-white py-2 px-6 rounded-lg shadow hover:bg-teal-600 focus:ring-2 focus:ring-teal-300 transition"
        >
          Go to Sign In
        </button>
      </div>
    </div>
  );
};

export default PrivateRoute;
